import sharedStyles from 'src/common/components/GridCard/_shared-styles.module.scss';
import styled from 'styled-components';

import Link from '~/src/common/components/Link';
import { FONTS } from '~/src/common/theme';
import { COLORS } from '~/src/common/theme';
import { SPECIALS } from '~/src/common/theme';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h4`
  margin-top: 0;
  margin-bottom: 8px;

  font-weight: 700;
  font-size: 20px;
`;

export const ViewAllLink = styled(Link)`
  font-size: 14px;
  font-weight: 500;
`;

export const SeeAllContainer = styled(Link)`
  display: grid;
  grid-template-rows: 1fr auto;
  grid-template-columns: 1fr;

  gap: 8px;
  border-radius: 4px;
  padding: 48px 8px 8px;
  aspect-ratio: ${sharedStyles['CARD_RATIO-card']};

  background: ${COLORS.NEUTRAL_DEFAULT};
  box-shadow: ${SPECIALS.SHADOW_NORMAL};

  background-position: -1% -1%;
  background-size: calc(102% / 6) calc(102% / 9);
  background-image: linear-gradient(${COLORS.NEUTRAL_WHITE} 2px, transparent 2px),
    linear-gradient(90deg, ${COLORS.NEUTRAL_WHITE} 2px, transparent 2px);

  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;

    gap: 8px;
    margin: 4px 8px;
    padding: 16px 16px 0;

    text-align: center;
    border-radius: 4px;
    color: ${COLORS.NEUTRAL_DEFAULT};
    background: ${COLORS.GROUND_UNDERGROUNDLIGHT};

    p {
      margin: 0;
      padding: 0;
      text-wrap: balance;

      font-size: 22px;
      font-weight: 700;
      font-family: ${FONTS.ARTZ};
    }

    [role='img'] {
      color: inherit;
    }
  }

  > button {
    height: 40px;
    border: 0 none;
    border-radius: 4px;
    pointer-events: none;

    font-size: 16px;
    font-weight: 700;

    color: ${COLORS.NEUTRAL_WHITE};
    background: ${COLORS.ACTION_DEFAULT};
  }

  &:hover {
    button {
      background: ${COLORS.ACTION_HOVER};
    }
  }
`;
